// 播放器错误提示
export default {
  linux_tv_playErr_video: {
    en: 'This video can\'t be played. Please try another one.',
    'zh-cn': '当前视频不可播，请观看其他内容',
    'zh-tw': '目前影片不可播，請觀看其他內容',
    th: 'วิดีโอในขณะนี้ไม่พร้อมใช้งาน กรุณารับชมเนื้อหาอื่น',
    vi: 'Video hiện tại không thể phát, vui lòng xem nội dung khác',
    id: 'Video tidak bisa diputar, silakan tonton yang lain.',
    hi: '',
    ms: 'Video semasa tidak tersedia, sila tonton kandungan lain',
    ar: '',
    ja: '',
    ko: '현재 영상 재생 불가, 다른 콘텐츠를 시청하세요',
    es: 'El video actual no se puede reproducir, vea otro contenido.',
    pt: 'O vídeo atual não pode ser reproduzido, assista a outros conteúdos.',
  },
  linux_tv_playErr_defn: {
    en: 'This resolution isn\'t available. Please try another one.',
    'zh-cn': '当前清晰度不可播，请尝试切换其他清晰度',
    'zh-tw': '目前清晰度不可播，請嘗試切換其他清晰度',
    th: 'ระดับความคมชัดนี้ไม่สามารถใช้งานได้ โปรดเปลี่ยนเป็นระดับอื่น',
    vi: 'Độ phân giải này không khả dụng, hãy thử chuyển sang độ khác',
    id: 'Resolusi ini tidak bisa diputar. Silakan pilih resolusi lainnya.',
    hi: '',
    ms: 'Resolusi semasa tidak tersedia. Sila cuba tukar ke resolusi lain.',
    ar: '',
    ja: '',
    ko: '이 화질은 재생할 수 없습니다. 다른 화질을 선택해 보세요.',
    es: 'Esta resolución no está disponible. Intente cambiar a otra.',
    pt: 'Esta qualidade de vídeo não está disponível. Tente mudar para outra.',
  },
  linux_tv_playErr_notTv: {
    en: 'The current device does not support playing this content, please watch on your mobile phone',
    'zh-cn': '当前设备无法播放此内容，请在手机上观看',
    'zh-tw': '當前裝置無法播放此內容，請在手機上觀看',
    th: 'อุปกรณ์นี้ไม่รองรับเนื้อหานี้ กรุณารับชมบนโทรศัพท์มือถือ',
    vi: 'Thiết bị này không hỗ trợ nội dung, hãy xem trên điện thoại',
    id: 'Perangkat ini tidak mendukung konten ini. Silakan tonton di ponsel.',
    hi: '',
    ms: 'Peranti ini tidak menyokong kandungan ini. Sila tonton di telefon anda.',
    ar: '',
    ja: '',
    ko: '현재 디바이스는 해당 콘텐츠 재생을 지원하지 않습니다. 모바일로 시청해 주세요',
    es: 'El dispositivo actual no es compatible con este contenido, véalo en su celular.',
    pt: 'Este dispositivo não suporta este conteúdo. Assista no seu celular.',
  },
  linux_tv_playErr_contentFail: {
    en: 'Something went wrong. Tap to try again.',
    'zh-cn': '内容加载失败，请重试',
    'zh-tw': '內容加載失敗，請重試',
    th: 'โหลดเนื้อหาล้มเหลว กรุณาลองอีกครั้ง',
    vi: 'Tải nội dung thất bại, hãy nhấn để thử lại',
    id: 'Gagal memuat konten, silakan coba lagi.',
    hi: '',
    ms: 'Kandungan gagal dimuatkan, sila cuba lagi.',
    ar: '',
    ja: '',
    ko: '콘텐츠 로딩 실패, 다시 시도해 주세요',
    es: 'Error al cargar, pulsa para intentarlo de nuevo',
    pt: 'Falha ao carregar conteúdo. Clique para tentar novamente',
  },
  linux_tv_downloadApp_scanQr: {
    en: 'Scan the QR code to download the app',
    'zh-cn': '扫描二维码下载App',
    'zh-tw': '掃描二維碼下載App',
    th: 'สแกนคิวอาร์โค้ดเพื่อดาวน์โหลดแอป',
    vi: 'Quét mã QR để tải app',
    id: 'Pindai kode QR untuk unduh aplikasi.',
    hi: '',
    ms: 'Imbas kod QR untuk muat turun aplikasi.',
    ar: '',
    ja: '',
    ko: 'QR 코드를 스캔하여 모바일 앱을 다운받으세요',
    es: 'Escanee el código QR para descargar la aplicación móvil.',
    pt: 'Escaneie o código QR para baixar o app.',
  },
  linux_tv_errorCode: {
    en: 'Error code',
    'zh-cn': '错误码',
    'zh-tw': '錯誤碼',
    th: 'รหัสความผิดพลาด',
    vi: 'Mã lỗi',
    id: 'Terjadi kesalahan',
    hi: '',
    ms: 'Kod ralat',
    ar: '',
    ja: '',
    ko: '오류 코드',
    es: 'Código de error',
    pt: 'Código de erro',
  },
  linux_tv_retry: {
    en: 'Retry',
    'zh-cn': '重试',
    'zh-tw': '重試',
    th: 'ลองอีกครั้ง',
    vi: 'Thử lại',
    id: 'Coba lagi',
    hi: '',
    ms: 'Cuba lagi',
    ar: '',
    ja: '',
    ko: '다시 시도',
    es: 'Reintentar',
    pt: 'Tentar novamente',
  },
};
